// extracted by mini-css-extract-plugin
export default {"pickable":"PatientOption_pickable__dtEWh","label":"PatientOption_label__ELtxR","active":"PatientOption_active__py2Ch"};